import { render, staticRenderFns } from "./AcessKey.vue?vue&type=template&id=610060d4&"
import script from "./AcessKey.vue?vue&type=script&lang=js&"
export * from "./AcessKey.vue?vue&type=script&lang=js&"
import style0 from "./AcessKey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports